import { ClientOptions, ClientProps } from '@/interfaces/models/client';
import { AsYouType } from 'libphonenumber-js';
import Review from '@/models/review';
import {ReviewProps} from "@/interfaces/models/review";

export default class Client {
  public avatar: string | null = null;
  public color: string = '';
  public comment: string | null = null;
  public email: string | null = null;
  public id: string = '';
  public name: string = '';
  public options: ClientOptions = ClientOptions.NORMAL;
  public phone: string = '';
  public totalSpent: number = 0;
  public lastUnreadMessage: string = '';
  public unreadMessageCount: number = 0;
  public unreadReviews: Review[] = [];

  [key: string]: any;

  public static createFromRequest(clientProps: ClientProps): Client {
    const client = new Client();

    client.avatar = clientProps.avatar;
    client.color = clientProps.color;
    client.comment = clientProps.comment;
    client.email = clientProps.email;
    client.id = clientProps.id;
    client.name = clientProps.name;
    client.options = clientProps.options;
    client.phone = new AsYouType().input(clientProps.phone);
    client.totalSpent = clientProps.totalSpent;
    client.lastUnreadMessage = clientProps.lastUnreadMessage;
    client.unreadMessageCount = clientProps.unreadMessageCount;

    if (clientProps.unreadReviews) {
      client.unreadReviews = clientProps.unreadReviews.map((props: ReviewProps): Review => new Review(props));
    }

    return client;
  }

  get isFavorite(): boolean {
    return ClientOptions.FAVORITE === this.options;
  }

  get isBanned(): boolean {
    return ClientOptions.BANNED === this.options;
  }

  get isNormal(): boolean {
    return ClientOptions.NORMAL === this.options;
  }

  get isActive(): boolean {
    return this.hasUnreadMessages || this.hasUnreadReviews;
  }

  get hasUnreadMessages(): boolean {
    return this.unreadMessageCount > 0;
  }

  get hasUnreadReviews(): boolean {
    return this.unreadReviews.length > 0;
  }

  get firstLetterOfName(): string {
    if (this.name.length === 0) {
      return '';
    }

    return this.name[0].toUpperCase();
  }

  get activityCount() {
    return this.unreadMessageCount + this.unreadReviews.length;
  }

  mergeWithNewFields(clientProps: ClientProps) {
    for (let key in clientProps) {
      if (clientProps.hasOwnProperty(key) && this.hasOwnProperty(key)) {
        this[key] = clientProps[key];
      }
    }
  }

  makeNormal() {
    this.options = ClientOptions.NORMAL;
  }

  makeFavorite() {
    this.options = ClientOptions.FAVORITE;
  }

  makeBanned() {
    this.options = ClientOptions.BANNED;
  }
}
